/**
 * Standardized date formats for consistent display across the application
 */
const STANDARD_DATE_FORMATS = {
  FULL_DATE: 'MMM D, YYYY', // Sep 11, 2024
  MONTH_YEAR: 'MMM, YYYY', // Sep, 2024
  QUARTER_YEAR: '[Q]Q YYYY', // Q3 2024
  YEAR_ONLY: 'YYYY', // 2024
} as const;

/**
 * Default timezone for operations
 */
const DEFAULT_TIMEZONE = 'UTC';

/**
 * Error messages for date operations
 */
const ERROR_MESSAGES = {
  INVALID_DATE: 'Invalid date provided',
  INVALID_FORMAT: 'Invalid date format',
  PARSE_ERROR: 'Failed to parse date string',
} as const;

export { DEFAULT_TIMEZONE, ERROR_MESSAGES, STANDARD_DATE_FORMATS };
